<div class="container-fluid cw-background mb-5 manage-view">
  <div class="row">
    <div class="col-12">
      <mat-card class="mat-elevation-z8 mt-3 pb-5" id="card">
        <!-- Header -->
        <div class="row">
          <div class="col-12 text-left go-back">
            <button (click)="onGoBack()" disableRipple mat-button class="p-0">
              <mat-icon matPreffix>arrow_back_ios</mat-icon>
              <span>Go Back</span>
            </button>
            <h6 class="card-title-page mt-2 mb-4">Edit Contract:</h6>
          </div>
        </div>
        <!-- Form -->
        <div class="row" *ngIf="contract">
          <!-- Dynamic form -->
          <div class="col">
            <app-dynamic-form
              [questions]="questions"
              (formSubmit)="onUpdateContract()"
              (hasChanged)="onChangeContract($event)"
              [class]="currentUser | applyFunctionOrValue: getManageFormClass"
              [disabled]="!isEditing"
              [showButtons]="false"
            >
              <div *ngIf="showAttachmentTab" class="dynamic-form-table" dynamic-form-table>
                <h6 class="dynamic-form-table-title">Attachments:</h6>
                <app-data-table
                  *ngIf="contract"
                  [config]="contractAttachmentsTableConfig"
                  (getData)="getContractAttachments($event)"
                  (updateData)="contractAttachmentTableService.update($event)"
                ></app-data-table>
              </div>
            </app-dynamic-form>
          </div>

          <div class="contract-banner" *ngIf="showActionBanner()">
            <div class="contract-buttons">
              <button mat-raised-button color="accent" [hidden]="!isEditing" (click)="dynamicForm.onSubmit()">
                Save
              </button>
              <button
                *ngIf="currentUser | applyFunctionOrValue: canEdit"
                (click)="onToggleManageContract()"
                class="btn-secondary-blue"
                mat-stroked-button
                color="accent"
                [hidden]="isEditing"
              >
                Edit
              </button>
              <button
                class="btn-secondary-blue"
                mat-stroked-button
                color="accent"
                *ngIf="canDelete(contract)"
                (click)="onDeleteContract()"
              >
                Delete Contract
              </button>
            </div>
            <div class="welcome-letter-button">
              <button
                class="btn-secondary-blue"
                mat-stroked-button
                color="accent"
                (click)="onGetWelcomeLetter()"
                [hidden]="!this.currentUser.isGlobal()"
              >
                Welcome Letter Generator
              </button>
            </div>
          </div>
        </div>
        <!-- Tabs -->
        <div class="row mt-5">
          <div class="col-12">
            <mat-tab-group [@.disabled]="true" (selectedTabChange)="onTabChange()">
              <mat-tab label="Assets">
                <app-data-table
                  *ngIf="contract"
                  [config]="contractAssetsTableConfig"
                  (getData)="getContractAssets($event)"
                  (updateData)="onUpdateContractAsset($event)"
                ></app-data-table>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
